import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';

import { RootState } from "../../../../store";
import { redirectToURL } from '../../../../utils/url';
import { ReactComponent as CartIcon } from '../../../../assets/icons/cart-icon.svg';
import { useGetCartByCartIdQuery } from '../../../../store/newCart';
import i18n from '../../../../utils/translations/i18n';
import { config } from '../../../../utils/config';

export const MiniCartMobile = (props) => {
    const { t } = i18n;
    const { applicationState: { user} } = useSelector((state: RootState) => state);    
    const {data, isFetching} = useGetCartByCartIdQuery({cartId: user.cartId, userId: user.userId, isLoggedIn: user.isLoggedIn}, {skip : (!user.userId || !user.cartId)});

    const miniCartLinkElement = document.getElementById('mini-cart-link-mobile');
    const handleViewCartButtonClick = () => redirectToURL(`${t('shopping_cart_details.shoppingPageUrl')}`);

    const miniCartPortal = (
        <a href={`/${config('locale_details').current_sitename}/${t('shopping_cart_details.shoppingPageUrl')}`} onClick={handleViewCartButtonClick}>
            <CartIcon fill='#080A54' />
            <span className="cart-count">{isFetching ? '' : data?.mainItemCount ?? 0}</span>
            <span className="cart-text">{t('header.cart')}</span>
        </a>
    );
    return miniCartLinkElement ? createPortal(miniCartPortal, miniCartLinkElement || document.body) : <></>;
};
